export default __webpack_public_path__ + "static/Plots0071-9ce362d5dae4d90e6ddcb89b735a04d2.jpg";